import { render, staticRenderFns } from "./Activity-Log.vue?vue&type=template&id=ca8d5e38&"
import script from "./Activity-Log.vue?vue&type=script&lang=js&"
export * from "./Activity-Log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports